import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faSync,
  faPlus,
  faEye,
  faPencilAlt,
  faTrash,
  faSort,
  faSortUp,
  faSortDown,
  faSun,
  faMoon,
} from '@fortawesome/free-solid-svg-icons';

// Register commonly used icons globally so components can reference icons by string
library.add(faSync, faPlus, faEye, faPencilAlt, faTrash, faSort, faSortUp, faSortDown, faSun, faMoon);

export default {};
